import { useEffect, useState } from "react";
import { Breadcrumb, Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import { FaCashRegister, FaSave, FaSearch } from "react-icons/fa";
import { getData, postData } from "../../../api/ApiRest";
import { formatDateddMMMyyyy } from "../../../widgets/DateTime";
import { formatNumber } from "../../../widgets/FormatNumber";
import LoadingComponent from "../../../widgets/LoadingComponent";
import { FaCheck, FaEye, FaPrint, FaXmark } from "react-icons/fa6";
import AsyncSelect from 'react-select/async';

function Recibos() {
    const [loading, setLoading] = useState(false);

    const [dataBuscar, setDataBuscar] = useState({});
    const [recibos, setRecibos] = useState([]);

    const [modalDocumentosVisible, setModalDocumentosVisibles] = useState({
        ModalVisible: false, Titulo: ''
    });

    const [modalRecibosVisibles, setModalRecibosVisibles] = useState({
        ModalVisible: false, Titulo: ''
    });

    const [documentosPosGold, setDocumentoPosGold] = useState([]);
    const [recibosPosGold, setRecibosPosGold] = useState([]);

    useEffect(() => {
        const fechaActual = new Date();
        fechaActual.setDate(fechaActual.getDate() - 15);

        setDataBuscar({
            ...dataBuscar,
            FechaIni: fechaActual.toISOString().split('T')[0],
            FechaFin: new Date().toISOString().split('T')[0]
        });
    }, [])


    const buscarRecibos = (event) => {
        event.preventDefault();
        setLoading(true);

        getData('api/Configuracion/UtilityPublic/buscarRecibos', {
            fechaini: dataBuscar.FechaIni,
            fechafin: dataBuscar.FechaFin,
            numero: dataBuscar.Numero || ''
        }).then(response => {

            if (dataBuscar.Cliente) {
                let valoresRecibos = response.recibos.filter(x => Number(x.companyid) === Number(dataBuscar.Cliente));
                setRecibos(valoresRecibos);
            } else {
                setRecibos(response.recibos);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para totalizar los totales de manera global
    const totalGlobal = () => {
        let total = 0;

        recibos.map((item, index) => {
            total += item.valor
        })

        return total;
    }

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                return response.companies;
            }, error => {
                return [];
            })
    }

    const [frame, setFrame] = useState({
        ModalVisible: false, Token: '', Documento: ''
    });

    const visualizarRecibo = (Documento, Token) => {
        setFrame({
            ModalVisible: true,
            Documento: Documento,
            Token: Token
        });
    }

    const generarDocumentos = async () => {
        let datos = recibosPosGold.filter(item => item.selected === true);

        for (let i = 0; i < datos.length; i++) {
            const item = datos[i];
            //{item.prefijo} - {item.numero}

            setRecibosPosGold(prev =>
                prev.map((data, index) =>
                    (data.prefijo === item.prefijo && data.numero === item.numero) ? { ...data, loading: true } : data
                )
            )

            let peticionPosGolds = {
                Prefijo: item.prefijo,
                Numero: item.numero,
                Documento: item.documento,
                Valor: item.valor,
                Nit: item.nit,
                Fecha: item.fecha,
                Tercero: item.tercero,
                Factura: item.factura,
                Cruce: item.cruce,
                PrefijoFactura: item.prefijoFactura,
                NumeroFactura: item.numeroFactura
            };

            try {
                await postData('api/Configuracion/Factura/generarDocumentosPosGold', {},
                    peticionPosGolds).then(response => {
                        setRecibosPosGold(prev =>
                            prev.map((data, index) =>
                                (data.prefijo === item.prefijo && data.numero === item.numero) ?
                                    {
                                        ...data,
                                        status: response.resultado[0].status,
                                        mensaje: response.resultado[0].mensaje,
                                        loading: false
                                    }
                                    : data
                            )
                        )
                    }, error => {
                        console.log(error);

                        setRecibosPosGold(prev =>
                            prev.map((data, index) =>
                                index === i ?
                                    {
                                        ...data,
                                        status: false,
                                        mensaje: error,
                                        loading: false
                                    }
                                    : data
                            )
                        )
                    })
            } catch (error) {
                console.log(error);
            }
        }
    }

    const generarRecibos = async () => {

        let datos = documentosPosGold.filter(item => item.selected === true);

        for (let i = 0; i < datos.length; i++) {
            const item = datos[i];
            //{item.prefijo} - {item.numero}

            setDocumentoPosGold(prev =>
                prev.map((data, index) =>
                    (data.prefijo === item.prefijo && data.numero === item.numero) ? { ...data, loading: true } : data
                )
            )

            let peticionPosGolds = {
                Prefijo: item.prefijo,
                Numero: item.numero,
                Documento: item.documento,
                Valor: item.valor,
                Nit: item.nit,
                Fecha: item.fecha,
                Tercero: item.tercero,
                Factura: item.factura,
                Cruce: item.cruce,
                PrefijoFactura: item.prefijoFactura,
                NumeroFactura: item.numeroFactura
            };

            try {
                await postData('api/Configuracion/Factura/generarDocumentosPosGold', {},
                    peticionPosGolds).then(response => {
                        setDocumentoPosGold(prev =>
                            prev.map((data, index) =>
                                (data.prefijo === item.prefijo && data.numero === item.numero) ?
                                    {
                                        ...data,
                                        status: response.resultado[0].status,
                                        mensaje: response.resultado[0].mensaje,
                                        loading: false
                                    }
                                    : data
                            )
                        )
                    }, error => {
                        console.log(error);

                        setDocumentoPosGold(prev =>
                            prev.map((data, index) =>
                                index === i ?
                                    {
                                        ...data,
                                        status: false,
                                        mensaje: error,
                                        loading: false
                                    }
                                    : data
                            )
                        )
                    })
            } catch (error) {
                console.log(error);
            }
        }
    }

    const visualizarDocumentos = async () => {
        setLoading(true);

        await getData('api/Configuracion/Factura/visualizarDocumentos', {
            categoria: 'CRD',
            fechaini: new Date('2024-01-01').toISOString(),
            fechafin: new Date().toISOString()
        }).then(response => {
            if (response.status) {
                setDocumentoPosGold(response.agrupacion);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    };

    const visualizarRecibos = async () => {
        setLoading(true);

        await getData('api/Configuracion/Factura/visualizarRecibos', {
            categoria: 'RC',
            fechaini: new Date('2024-01-01').toISOString(),
            fechafin: new Date().toISOString(),
            ruta: window.location.hostname
        }).then(response => {
            console.log(response);
            if (response.status) {
                setRecibosPosGold(response.agrupacion);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    const selectedTodo = (valor) => {
        setDocumentoPosGold(prev =>
            prev.map(item => ({
                ...item,
                selected: valor
            }))
        )
    }

    const selectedTodoV2 = (valor) => {
        setRecibosPosGold(prev =>
            prev.map(item => ({
                ...item,
                selected: valor
            }))
        )
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item style={{ fontSize: 14 }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>Recibos</Breadcrumb.Item>
        </Breadcrumb>

        {<LoadingComponent Loading={loading} />}

        <div className="d-flex gap-1">
            <button className="btn btn-sm btn-warning" title="Visualizar cruces" onClick={() => {
                setModalDocumentosVisibles({
                    ModalVisible: true, Titulo: 'Visualizar cruces'
                });

                visualizarDocumentos();
            }}>
                <FaEye />
            </button>
            <button className="btn btn-sm btn-success" title="Visualizar recibos" onClick={() => {
                setModalRecibosVisibles({
                    ModalVisible: true, Titulo: 'Visualizar recibos'
                });

                visualizarRecibos();
            }}>
                <FaCashRegister />
            </button>
        </div>

        <br />

        <Form onSubmit={buscarRecibos}>
            <div className='row'>
                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Fecha Inicial"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            placeholder="Fecha"
                            value={dataBuscar.FechaIni}
                            onChange={value => setDataBuscar({ ...dataBuscar, FechaIni: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Fecha Final"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            placeholder="Fecha"
                            value={dataBuscar.FechaFin}
                            onChange={value => setDataBuscar({ ...dataBuscar, FechaFin: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId='Numero'
                        label="Número"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="number"
                            placeholder="Número"
                            value={dataBuscar.Numero}
                            onChange={value => setDataBuscar({ ...dataBuscar, Numero: value.target.value })}
                            className="input-fecha-sm"
                            min={0}
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-5'>
                    <AsyncSelect cacheOptions defaultOptions
                        menuPosition='fixed'
                        noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                        placeholder="Cliente"
                        isClearable={true}
                        loadOptions={companieSearchSelect2}
                        onChange={value => {
                            if (value === null)
                                setDataBuscar({ ...dataBuscar, Cliente: '' })
                            else
                                setDataBuscar({ ...dataBuscar, Cliente: value.value })
                        }}
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: 50
                            })
                        }}
                    />
                </div>

                <div className='col-md-1'>
                    <Button variant='primary' type='submit' size="sm">
                        <FaSearch size={'0.8rem'} />
                    </Button>
                </div>

            </div>
        </Form>

        <div className="row">
            <div className='table-responsive mt-2'>
                <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className="estilo-encabezado"></th>
                            <th className="estilo-encabezado">#</th>
                            <th className="estilo-encabezado">
                                Documento
                            </th>
                            <th className="estilo-encabezado">
                                Fecha
                            </th>
                            <th className="estilo-encabezado">
                                Identificación
                            </th>
                            <th className="estilo-encabezado">
                                Cliente
                            </th>
                            <th className="estilo-encabezado">
                                Valor
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {recibos.map((item, index) => (
                            <tr key={index} style={{ fontSize: 14 }}>
                                <td className="text-center">
                                    <Button type="button" variant="warning" onClick={() => visualizarRecibo(item.prefijo + " - " + item.numero, item.token)}
                                        style={{
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            fontSize: 12
                                        }}>
                                        <FaPrint />
                                    </Button>
                                </td>
                                <td className="text-center">
                                    {index + 1}
                                </td>
                                <td className="text-center">
                                    {item.prefijo} - {item.numero}
                                </td>
                                <td className="text-center">
                                    {formatDateddMMMyyyy(item.fecha)}
                                </td>
                                <td className="text-center">
                                    {item.nit}
                                </td>
                                <td>
                                    {item.tercero}
                                </td>
                                <td style={{ textAlign: 'right' }}>
                                    $ {formatNumber(item.valor)}
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total</td>
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                $ {formatNumber(totalGlobal())}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <Modal
            show={frame.ModalVisible}
            size="lg"
            onHide={() => {
                setFrame({
                    ModalVisible: false, Documento: '', Token: ''
                });
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Impresión {frame.Documento}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <iframe
                    src={"https://tae.goldpos.com.co/ReporteApp/Recibo/ImprimirReciboTaecol?documento=" + frame.Token}
                    width="100%"
                    height="450px"
                    style={{ marginTop: "20px", border: "1px solid #ccc" }}
                    title="Reporte PDF"
                ></iframe>
            </Modal.Body>
        </Modal>

        <Modal
            show={modalRecibosVisibles.ModalVisible}
            size="xl"
            onHide={() => {
                setModalRecibosVisibles({
                    ModalVisible: false, Titulo: ''
                });

                setRecibosPosGold([]);
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalRecibosVisibles.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {recibosPosGold.length > 0 ? <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className="estilo-encabezado">#</th>
                            <th className="estilo-encabezado">
                                Recibo
                            </th>
                            <th className="estilo-encabezado">
                                Factura
                            </th>
                            <th className="estilo-encabezado">
                                Fecha
                            </th>
                            <th className="estilo-encabezado">
                                Identificación
                            </th>
                            <th className="estilo-encabezado">
                                Cliente
                            </th>
                            <th className="estilo-encabezado">
                                Valor
                            </th>
                            <th className="estilo-encabezado">
                                <button className="btn btn-sm btn-dark" title="Seleccionar todo" onClick={() => selectedTodoV2(true)} onDoubleClick={() => selectedTodoV2(false)}>
                                    <FaCheck />
                                </button>
                                <button className="btn btn-sm btn-success" title="Generar recibos" onClick={() => generarDocumentos()}>
                                    <FaSave />
                                </button>
                            </th>
                            <th className="estilo-encabezado">
                                Estado
                            </th>
                            <th className="estilo-encabezado">
                                Mensaje
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {recibosPosGold.map((item, index) => (
                            <tr key={index} style={{ fontSize: 12 }}>
                                <td className="text-center">
                                    {index + 1}
                                </td>
                                <td className="text-center">
                                    {item.prefijo} - {item.numero}
                                </td>
                                <td className="text-center">
                                    {item.factura}
                                </td>
                                <td className="text-center">
                                    {formatDateddMMMyyyy(item.fecha)}
                                </td>
                                <td className="text-center">
                                    {item.nit}
                                </td>
                                <td>
                                    {item.tercero}
                                </td>
                                <td style={{ textAlign: 'right' }}>
                                    ${formatNumber(item.valor)}
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <Form.Check checked={item.selected}
                                        onChange={event =>
                                            setRecibosPosGold(
                                                recibosPosGold.map(p => p.prefijo === item.prefijo && p.numero === item.numero ?
                                                    { ...p, selected: !item.selected } : p
                                                )
                                            )
                                        } />
                                </td>
                                <td className='text-center'>
                                    {item.loading ? <img
                                        alt="loading"
                                        src="/tav-loading.gif"
                                        style={{ width: 20 }} /> :
                                        item.status ? <FaCheck size={'1rem'} /> : <FaXmark size={'1rem'} />}
                                </td>
                                <td className='text-center'>
                                    {item.mensaje}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table> : null}

            </Modal.Body>
        </Modal>

        <Modal
            show={modalDocumentosVisible.ModalVisible}
            size="xl"
            onHide={() => {
                setModalDocumentosVisibles({
                    ModalVisible: false, Titulo: ''
                });

                setDocumentoPosGold([]);
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalDocumentosVisible.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {documentosPosGold.length > 0 ? <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className="estilo-encabezado">#</th>
                            <th className="estilo-encabezado">
                                Documento
                            </th>
                            <th className="estilo-encabezado">
                                Recibo
                            </th>
                            <th className="estilo-encabezado">
                                Factura
                            </th>
                            <th className="estilo-encabezado">
                                Fecha
                            </th>
                            <th className="estilo-encabezado">
                                Identificación
                            </th>
                            <th className="estilo-encabezado">
                                Cliente
                            </th>
                            <th className="estilo-encabezado">
                                Valor
                            </th>
                            <th className="estilo-encabezado">
                                <button className="btn btn-sm btn-dark" title="Seleccionar todo" onClick={() => selectedTodo(true)} onDoubleClick={() => selectedTodo(false)}>
                                    <FaCheck />
                                </button>
                                <button className="btn btn-sm btn-success" title="Generar recibos" onClick={() => generarRecibos()}>
                                    <FaSave />
                                </button>
                            </th>
                            <th className="estilo-encabezado">
                                Estado
                            </th>
                            <th className="estilo-encabezado">
                                Mensaje
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {documentosPosGold.map((item, index) => (
                            <tr key={index} style={{ fontSize: 12 }}>
                                <td className="text-center">
                                    {index + 1}
                                </td>
                                <td className="text-center">
                                    {item.cruce}
                                </td>
                                <td className="text-center">
                                    {item.prefijo} - {item.numero}
                                </td>
                                <td className="text-center">
                                    {item.factura}
                                </td>
                                <td className="text-center">
                                    {formatDateddMMMyyyy(item.fecha)}
                                </td>
                                <td className="text-center">
                                    {item.nit}
                                </td>
                                <td>
                                    {item.tercero}
                                </td>
                                <td style={{ textAlign: 'right' }}>
                                    ${formatNumber(item.valor)}
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <Form.Check checked={item.selected}
                                        onChange={event =>
                                            setDocumentoPosGold(
                                                documentosPosGold.map(p => p.prefijo === item.prefijo && p.numero === item.numero ?
                                                    { ...p, selected: !item.selected } : p
                                                )
                                            )
                                        } />
                                </td>
                                <td className='text-center'>
                                    {item.loading ? <img
                                        alt="loading"
                                        src="/tav-loading.gif"
                                        style={{ width: 20 }} /> :
                                        item.status ? <FaCheck size={'1rem'} /> : <FaXmark size={'1rem'} />}
                                </td>
                                <td className='text-center'>
                                    {item.mensaje}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table> : null}

            </Modal.Body>
        </Modal>
    </div>
}

export default Recibos;